import { AvatarSize, Box, Icon, IconSize, Text } from '@bechtel/gds';
import { useAppPermissions, useAppUser } from '@bechtel/ht-clients-common';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { envConfig } from '../../env-config';
import { EmulateAction } from '../atoms';

import { navigationRoutes } from '~/app-data/navigation-routes';
import { HorseTraderLogo } from '~/images';
import UserPhoto from '../molecules/user-photo';
import {
  LinkStyled,
  LogoSectionStyled,
  NavigationContentStyled,
  NavigationStyled,
  UserAdminLinkStyled,
  UserEmulateStyled,
  UserSettingSectionStyled,
} from './styled';

interface NavItemProps {
  icon: IconName;
  name: string;
  fillColor?: string;
  size?: IconSize;
  iconStyle?: any;
}
const NavItem: React.FC<NavItemProps> = ({ icon, name, fillColor = 'blue.800', size = IconSize.MEDIUM, iconStyle }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} alignItems={{ sm: 'center' }}>
      {iconStyle ? (
        <Icon iconStyle={iconStyle} icon={icon} size={size} fillColor={fillColor} />
      ) : (
        <Icon icon={icon} size={size} fillColor={fillColor} />
      )}
      <Text family={'openSansCondensed'} size="250" weight="200">
        {name}
      </Text>
    </Box>
  );
};

export const Navigation = () => {
  const { appUser } = useAppUser();
  const { hasPermission } = useAppPermissions();

  return (
    <NavigationContentStyled>
      <LogoSectionStyled>
        <HorseTraderLogo></HorseTraderLogo>
      </LogoSectionStyled>
      <NavigationStyled>
        {navigationRoutes.map((route) => {
          return (
            hasPermission(route.permission) && (
              <LinkStyled key={route.name} to={route.path}>
                <NavItem name={route.name} icon={route.icon}></NavItem>
              </LinkStyled>
            )
          );
        })}
      </NavigationStyled>
      {/* Not Required as of now.(As discussed with Sid) <LinkStyled isNav key={i18next.t('Quick Find')} to={''}>
        <NavItem iconStyle={'solid'} name={i18next.t('Quick Find')} icon={'folder-magnifying-glass'}></NavItem>
      </LinkStyled> */}
      {!!envConfig.enableEmulation && (
        <UserEmulateStyled>
          <EmulateAction toggle={() => {}}></EmulateAction>
        </UserEmulateStyled>
      )}
      {hasPermission('VIEW_USER_ADMIN') && (
        <UserAdminLinkStyled key="project-admin" to="/project-admin">
          <NavItem name="" icon="user-gear" size={IconSize.LARGE} fillColor="primary.700"></NavItem>
        </UserAdminLinkStyled>
      )}
      <UserSettingSectionStyled>
        <UserPhoto
          fontSize="500"
          imageUrl={appUser?.employee?.imageUrl || ''}
          size={AvatarSize.LARGE}
          user={appUser}
          backgroundColor="white"
        ></UserPhoto>
      </UserSettingSectionStyled>
    </NavigationContentStyled>
  );
};
